import { Typography } from '@mui/material';
import { FC } from 'react';

interface IProps 
{
    sx?: {};
}

const ErrorText: FC<IProps> = ({ sx, children }) => 
{
    return children ? (<Typography sx={{color: "#ff0000", ...sx}}>
        {children}
    </Typography>) : (<></>);
};

export default ErrorText;